export { IdentifierMode };

const IdentifierMode = {
  FROM_IDENTIFIER: "fromIdentifier",
  ROTATE_IDENTIFER: "rotateIdentifiers",
} as const;

type IdentifierMode = (typeof IdentifierMode)[keyof typeof IdentifierMode];
